import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-suspend-popup',
  templateUrl: 'suspend-popup.component.html',
  styleUrls: ['./suspend-popup.component.less', '../shared/common.less'],
})
export class SuspendPopupComponent implements OnInit {
  @Output() payment = new EventEmitter<boolean>();
  @Input() message: string;
  @Input() endDate: string;
  @Input() startDate: string;
  @Input() validateButton: boolean;
  @Input() cancelButton: boolean;
  @Input() callButton: boolean;
  @Input() modifyButton: boolean;
  @Input() confirmButton: boolean;
  @Input() understoodButton: boolean;
  @Input() votingAvailableButtons: boolean;
  @Input() phoneInput: boolean;
  @Input() firstText: string;
  @Input() title: string;
  @Input() secondText: string;
  @Input() thirdText: string;
  @Input() index: number;
  @Input() isAssoc: boolean;
  @Input() origin: string;
  @Input() isValidated: boolean;

  @Output() contactPhone = new EventEmitter<string>();
  @Output() endDetailsPopup = new EventEmitter<boolean>();


  isPhoneValid = false;
  status: number;
  formattedDateRange: string;

  launch() {
    this.payment.emit(true);
  }

  clicAction($event) {
    if (
      $event.target.className === 'div-arriere-plan-action' ||
      $event.target.className === 'div-global-action'
    ) {
      this.cancelDetails(false);
    }
  }

  onPhoneEdit($event) {
    this.isPhoneValid = this.isValid($event.target.value);
  }

  isValid(p: string) {
    const phoneRe = /^\+?[\d]{0,15}$/;
    return phoneRe.test(p);
  }

  sendContactPhone() {
    const element = document.getElementById('phone-input') as HTMLInputElement;
    this.contactPhone.emit(element.value);
  }

  cancelDetails(value) {
    // this.endDetailsPopup.emit(value);
    
    window.close();
  }

  cancel() {
    this.payment.emit(false);
  }

  formatDateRange(startDateString: string, endDateString: string): string {
    if (!startDateString || !endDateString) return '';
    
    // Parse le format DD/MM/YYYY HH:MM
    const parseDate = (dateString: string): Date | null => {
      const regex = /(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})/;
      const match = dateString.match(regex);
      
      if (!match) return null;
      
      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10) - 1; // Les mois commencent à 0 en JavaScript
      const year = parseInt(match[3], 10);
      const hours = parseInt(match[4], 10);
      const minutes = parseInt(match[5], 10);
      
      return new Date(year, month, day, hours, minutes);
    };
    
    const startDate = parseDate(startDateString);
    const endDate = parseDate(endDateString);
    
    // Vérifie si les dates sont valides
    if (!startDate || !endDate || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return `Du ${startDateString} au ${endDateString}`;
    }
    
    const formatFullDate = (date: Date): string => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    };
    
    const formatTime = (date: Date): string => {
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    };
    
    // Vérifie si les dates sont le même jour
    const isSameDay = startDate.getDate() === endDate.getDate() &&
                      startDate.getMonth() === endDate.getMonth() &&
                      startDate.getFullYear() === endDate.getFullYear();
    
    if (isSameDay) {
      return `du ${formatFullDate(startDate)} à ${formatTime(endDate)}`;
    } else {
      return `du ${formatFullDate(startDate)} au ${formatFullDate(endDate)}`;
    }
  }

  ngOnInit() {
    if (this.origin === 'addVoters' || this.origin === 'addSMS') {
      this.status = 1;
    }
    
    // Formate les dates au chargement du composant
    this.formattedDateRange = this.formatDateRange(this.startDate, this.endDate);
  }
}
